
import Vue from 'vue'
import {NewWebsitesApiFunc, setAccessToken} from '@/api'
import { Website } from '@/models'

import TheTemplate from '../../TheNoSidebarTemplate.vue'
import BaseCloseButton from '@/components/BaseCloseButton.vue'

export type DataType = {
  website?: Website;
}

export default Vue.extend({
  name: 'WebsiteUrlDetailScreen',

  components: {
    TheTemplate,
    BaseCloseButton
  },

  data(): DataType {
    return {
      website: undefined
    }
  },

  computed: {
    urlDescText(): string {
      return this.website?.displayName || ''
    },

    urlText(): string {
      return `${process.env.VUE_APP_THRONE_VACANSERVICE_URL}/${this.website?.url}` || ''
    }
  },

  mounted() {
    this.getWebsite()
  },

  methods: {
    async getWebsite(): Promise<void> {
      const companyId = this.$auth.companyId
      if (!companyId) {
        this.$router.replace({name: 'login'})
        return
      }
      const websiteId = this.$router.currentRoute.params.websiteId
        setAccessToken(this.$auth.accessToken)
        const { data, err } = await NewWebsitesApiFunc().getWebsite(companyId, websiteId)

      if (err != null) {
        this.$handleApiError(err, this.getWebsite)
        return
      }

      this.website = data
    }
  }
})
